const ADDRESS_TYPES = {
  COMMERCIAL: 'commercial',
  RESIDENTIAL: 'residential',
}

export { ADDRESS_TYPES }
